import { h } from 'vue'
import { notification, message } from 'ant-design-vue'
import { debounce } from 'lodash-es'
// @ts-ignore
import html2canvas from 'html2canvas'
import moment from 'moment'

import store from '@/store'
import router, { sidebarRoutes } from '@/router'
// @ts-ignore
import { getOrgUserList } from '@/request'
// @ts-ignore
import { NUMBER_REG, LETTER_REG, CHINESE_REG, ORIGINAL_CHAR_REG } from '@/config/constant.cfg'

// AreaResult
import emc from '@/assets/dataModel/EnumModelContainer'
import menu from '@/assets/dataModel/menu'
import storage from '@/shared/storage'
import { Common } from '@/interface/common.interface'
import { Further } from '@/interface/further.interface'

/**
 * 获取url中的参数
 * @params key 需要从url中获取的字段名称
 * @describe 获取url中的参数
 */
export const getQueryString = (key: string) => {
  let { href } = window.location
  href = href.replace(/#\/.+/, '')
  const src = href.split('?')
  if (src[0] === href) {
    return ''
  }
  const arr = src[1].split('&')
  const obj: any = {}
  for (let i = 0; i < arr.length; i++) {
    const arr1 = arr[i].split('=')
    obj[arr1[0]] = arr1[1]
  }
  return (obj[key] || '').replace(/(\/|#).?/g, '')
}

/**
 * nameDesensitizeHandle: 脱敏处理.
 * @name 脱敏的信息
 * @mode 脱敏的模式，默认为userName 用户名字模式 剩下的模式为单位/学校模式
 * @open 是否开启脱敏
 */
export const nameDesensitizeHandle = (name: string, mode = 'userName', open = true) => {
  let newName = name

  if (
    store?.state?.pageState?.orgInfo?.showUserInfoSwitch &&
    window.localStorage.getItem('nameDesensitize') &&
    newName &&
    open
  ) {
    if (newName.length <= 3) {
      const surname = newName.slice(0, 1)
      newName = surname + '*'.repeat(newName.length > 5 ? 4 : newName.length - 1)
    } else {
      const length = mode === 'userName' ? 1 : 2
      const surname = newName.slice(0, 1)
      const tail = newName.slice(-length)
      const originLength = newName.length - length - 1
      let repeatlength = originLength > 4 ? 4 : originLength
      newName = surname + '*'.repeat(repeatlength) + tail
    }
  }

  return newName
}

// 根据antd的格式，格式化地区
export async function localFormat(localCodeColt: number[]) {
  // 初始化列表
  let list: Common.AreaResultTransfer[] = await emc.getAreaList()
  // 格式化结果
  let formatResult = ''
  // 遍历地区code
  localCodeColt.forEach((value: number, idx: number) => {
    // 筛选
    const result: Common.AreaResultTransfer[] = list.filter((item) => item.areaCode === value)
    formatResult += result[0].name
    // 判断非最后一级的逻辑
    if (result.length && idx < localCodeColt.length - 1) {
      list = result[0].children as unknown as Common.AreaResultTransfer[]
      formatResult += ' / '
    }
  })
  return formatResult
}
export function localCodeStrTransfer(codeStr: string) {
  return codeStr.split(',')
}

export function getType(data: any): string {
  return Reflect.toString
    .call(data)
    .replace(/\[object (.+)\]/, '$1')
    .toLowerCase()
}

export function isUndef(value: any) {
  return typeof value === 'undefined' || value === null
}

export function isDef(value: any) {
  return typeof value !== 'undefined' && value !== null
}

export const getUrlQuery = (): { [key: string]: string | number } => {
  const url = window.location.search
  const parmas = {}
  if (url.indexOf('?') !== -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      const s = strs[i].split('=')
      parmas[s[0]] = strs[i].slice(s[0].length + 1)
    }
  }
  return parmas
}

export function isEMOJI(substring: string) {
  if (substring) {
    for (let i = 0; i < substring.length; i++) {
      const hs = substring.charCodeAt(i)
      if (hs >= 0xd800 && hs <= 0xdbff) {
        if (substring.length > 1) {
          const ls = substring.charCodeAt(i + 1)
          const uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000
          if (uc >= 0x1d000 && uc <= 0x1f77f) {
            return true
          }
        }
      } else if (substring.length > 1) {
        const ls = substring.charCodeAt(i + 1)
        if (ls === 0x20e3) {
          return true
        }
      } else {
        if (hs >= 0x2100 && hs <= 0x27ff) {
          return true
        } else if (hs >= 0x2b05 && hs <= 0x2b07) {
          return true
        } else if (hs >= 0x2934 && hs <= 0x2935) {
          return true
        } else if (hs >= 0x3297 && hs <= 0x3299) {
          return true
        } else if (
          hs === 0xa9 ||
          hs === 0xae ||
          hs === 0x303d ||
          hs === 0x3030 ||
          hs === 0x2b55 ||
          hs === 0x2b1c ||
          hs === 0x2b1b ||
          hs === 0x2b50
        ) {
          return true
        }
      }
    }
  }
}

export const setCrumbs = debounce((crumbs: Common.Crumb[]) => {
  store.commit('setCrumbs', crumbs)
}, 300)

export function frozenPromise(fn: Function, time = 500) {
  let pedding = false
  let promise: Promise<any>
  return function (params?: any): Promise<any> {
    if (typeof fn !== 'function') throw new Error('[frozenPromise] error: 形参fn期望得到的是一个函数。')
    if (!pedding) {
      pedding = true
      promise = fn(params)
      setTimeout(() => {
        if (promise instanceof Promise) {
          promise.finally(() => {
            pedding = false
          })
        }
      }, time)
    }
    return promise
  }
}

export const findAreaByCode = (code: string | number, isAll = false) => {
  const areaList: Common.AreaResultTransfer[] = storage.get('areaList')
  const result: Common.AreaResult = {} as Common.AreaResult
  const arrResult: Common.AreaResult[] = [] as Common.AreaResult[]
  // 统一区域代码标准
  if (typeof code === 'number') {
    code = code.toString()
    if (code.length === 6) {
      code = code + '000000'
    }
  }
  const provCode = code.slice(0, 2) + '0000000000'
  const cityCode = code.slice(0, 4) + '00000000'
  // 当前区域为省级行政区
  if (provCode === code) {
    result.level = 'province'
    areaList.forEach((area: Common.AreaResultTransfer) => {
      if (area.areaCode === Number((code as string).slice(0, 6))) {
        result.areaCode = code
        result.name = area.name
        arrResult.push(result)
      }
    })
    // 当前区域为市级行政区
  } else if (cityCode === code) {
    result.level = 'city'
    areaList.forEach((prov: Common.AreaResultTransfer) => {
      if (prov.areaCode === Number((provCode as string).slice(0, 6)) && prov.children?.length) {
        arrResult.push({
          areaCode: prov.areaCode,
          name: prov.name,
        })
        prov.children.forEach((area) => {
          if (area.areaCode === Number((code as string).slice(0, 6))) {
            result.areaCode = code
            result.name = area.name
            arrResult.push({
              areaCode: code,
              name: area.name,
            })
          }
        })
      }
    })
    // 当前区域为区级行政单位
  } else {
    result.level = 'district'
    areaList.forEach((prov: Common.AreaResultTransfer) => {
      if (prov.areaCode === Number(provCode.slice(0, 6)) && prov.children?.length) {
        arrResult.push({
          areaCode: prov.areaCode,
          name: prov.name,
        })
        prov.children.forEach((city: Common.AreaResultTransfer) => {
          if (city.areaCode === Number(cityCode.slice(0, 6)) && city.children?.length) {
            arrResult.push({
              areaCode: city.areaCode,
              name: city.name,
            })
            city.children.forEach((area: Common.AreaResultTransfer) => {
              if (area.areaCode === Number((code as string).slice(0, 6))) {
                result.areaCode = code
                result.name = area.name
                arrResult.push({
                  areaCode: code,
                  name: area.name,
                })
              }
            })
          }
        })
      }
    })
  }
  return isAll ? arrResult : result
}

/**
 * 购买产品提示.
 */
export const buyTip = () => {
  notification.open({
    message: '购买产品请联系：',
    description: h('div', {}, [h('div', {}, '客服电话：400-992-0062'), h('div', {}, '商务邮箱：business@ipin.com')]),
  })
}

/**
 * 机构不支持转为1对1省份提示.
 */
export const orgNotSupportProvinceTip = () => {
  notification.open({
    message: '当前机构购买的版本权限不支持该省份的升学规划1对1服务',
    description: h('div', {}, [
      h('div', { class: 'title mt-15' }, '购买更多产品权限请联系：'),
      h('div', {}, '客服电话：400-992-0062'),
      h('div', {}, '商务邮箱：business@ipin.com'),
    ]),
  })
}

/**
 * 阿拉伯数字转中文数字
 *
 * @demo (12) => '一十二'
 * @param num 要转换的数字.
 * @returns 转换后的中文数字.
 */
export const numberToChinese = (num: number): string => {
  const AA: string[] = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const BB: string[] = ['', '十', '百', '千', '万', '亿', '点', '']
  const a = ('' + num).replace(/(^0*)/g, '').split('.')
  let re = ''
  let k = 0

  for (let i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re
        break
      case 4:
        if (!new RegExp('0{4}\\d{' + (a[0].length - i - 1) + '}$').test(a[0])) re = BB[4] + re
        break
      case 8:
        re = BB[5] + re
        BB[7] = BB[5]
        k = 0
        break
    }
    if (k % 4 === 2 && a[0].charAt(i + 2) !== '0' && a[0].charAt(i + 1) === '0') re = AA[0] + re
    if (a[0].charAt(i) !== '0') re = AA[a[0].charAt(i)] + BB[k % 4] + re
    k++
  }

  if (a.length > 1) {
    // 加上小数部分(如果有小数部分)
    re += BB[6]
    for (let i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)]
  }

  return re
}

/**
 * 根据权限过滤首页路由.
 */
export const getHomeRoute = () => {
  const permissionNameMap: object = menu.getSidebarRouteMap()
  const state = store.state as { user: { permission: { list: { menuId: number; op: number }[] } }; common: any }
  const permissionList = state.user.permission.list || []
  const filteredPermissionList: string[] = permissionList
    .filter((l) => l.menuId % 100 > 0 || l.menuId === 10000 || l.menuId === 1100)
    .filter((item) => !!permissionNameMap[item.menuId])
    .map((item) => permissionNameMap[item.menuId])

  return sidebarRoutes.filter((item) => filteredPermissionList.includes(item.name))[0]
}

/**
 * 登录后或者在404页面点击【前往首页】进入有权限的第一个路由.
 */
export const goHome = () => {
  router.push(getHomeRoute())
}

/**
 * 判断数组中的数字是否连续 (自然数).
 * ! @demo [ 1, 2, 3, 4 ] returns true.
 * ! @demo [ 1, 3, 5 ] returns false.
 *
 * @param a 要判断的数组.
 * @param len 在数组中前多少个数字中判断.
 * @returns 是否连续.
 */
export const isContinuous = (a: Array<number>, len: number) => {
  let max = -1
  let min = -1
  for (let i = 0; i < len; i++) {
    if (a[i] > max || max === -1) {
      max = a[i]
    }
    if (a[i] < min || min === -1) {
      min = a[i]
    }
  }
  if (max - min > len - 1) {
    return false
  } else {
    return true
  }
}

/**
 * 缓存机构老师数据.
 */
export const fetchAndStoreOrgUsers = async (
  params?
): Promise<{ orgUsersMap: Common.Map; orgUsers: Further.Counselor[] }> => {
  const orgUsersMap: Common.Map = {}
  const orgUsers: Further.Counselor[] = []

  const isSuperAdmin = store.getters.isSuperAdmin
  const isHasAppointPermission = store.getters.isHasAppointPermission
  if (isSuperAdmin || isHasAppointPermission) {
    const res = await getOrgUserList({
      super: params?.super || false,
      status: 1, // 1 表示正常状态用户, 不包含被禁用用户.
    })
    res.list = res.list || []
    res.list.forEach((item) => {
      orgUsersMap[item.userId] = item
      orgUsers.push(item)
    })
    storage.set('counselors', orgUsers)
    storage.set('counselorsMap', orgUsersMap)
    store.commit('setCounselors', orgUsers)
    store.commit('setCounselorsMap', orgUsersMap)
  } else {
    // message.warn('你未授权查询机构老师数据')
  }

  return {
    orgUsers,
    orgUsersMap,
  }
}

/**
 * 根据链接打开新窗口
 * @param {string} url 链接
 */
export const openNewWindow = (url: string, name?: string) => {
  const a = document.createElement('a')
  if (name) {
    a.download = name // 设置下载的文件名，默认是'下载'
  }
  a.href = url
  a.target = '_blank'
  document.body.appendChild(a)
  a.click()
  a.remove()
}
/**
 * 根据链接下载文件
 * @param {string} url 下载链接
 */
export const downloadFile = (url: string) => {
  openNewWindow(url)
}
/**
 * 复制文本
 * @param {string} t 需要复制的问题
 */
export const copyText = (t: string) => {
  const node = document.createElement('textarea') // input框
  document.body.appendChild(node)
  node.value = t
  node.setSelectionRange(0, 9999)
  node.select()
  document.execCommand('copy')
  node.remove()
  message.success('复制成功')
}

// canvas转base64
export const canvasToBase64 = (id, callback) => {
  const element = document.getElementById(id)
  if (element) {
    html2canvas(element).then((can) => {
      const pageData = can.toDataURL()
      callback(pageData)
    })
  }
}

// base64转blob
export const dataURItoBlob = (base64Data) => {
  let byteString
  if (base64Data.split(',')[0].indexOf('base64') >= 0) byteString = atob(base64Data.split(',')[1])
  // base64 解码
  else {
    byteString = unescape(base64Data.split(',')[1])
  }
  const mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0] // mime类型 -- image/png

  // var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
  // var ia = new Uint8Array(arrayBuffer);//创建视图
  const ia = new Uint8Array(byteString.length) // 创建视图
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i)
  }
  const blob = new Blob([ia], {
    type: mimeString,
  })
  return blob
}

// 复制到粘贴板
export const copyToClipboard = async (pngBlob) => {
  try {
    await (navigator.clipboard as any).write([
      // eslint-disable-next-line no-undef
      new (window as any).ClipboardItem({
        [pngBlob.type]: pngBlob,
      }),
    ])
    message.success('复制成功')
  } catch (error) {
    message.error('复制失败，请通过右键点击复制。')
  }
}
/**
 * 复制图片
 */
export const copyImgDom = (dom: HTMLElement) => {
  const range = document.createRange()
  range.selectNode(dom)
  window.getSelection()?.addRange(range)
  document.execCommand('copy')
  message.success('复制成功')
}

/**
 * 判断字符串中是否包含数字.
 */
export const includesNumber = (value: string): boolean => {
  let char

  for (let i = 0; i < value.length; i++) {
    char = value[i]

    if (NUMBER_REG.test(char)) {
      return true
    }
  }

  return false
}

/**
 * 判断字符串中是否包含字母.
 */
export const includesLetter = (value: string): boolean => {
  let char

  for (let i = 0; i < value.length; i++) {
    char = value[i]

    if (LETTER_REG.test(char)) {
      return true
    }
  }

  return false
}

/**
 * 判断字符串中是否包含除数字、英文、中文之外的特殊字符.
 */
export const includesSpecialChar = (value: string): boolean => {
  let char

  for (let i = 0; i < value.length; i++) {
    char = value[i]

    if (!NUMBER_REG.test(char) && !LETTER_REG.test(char) && !CHINESE_REG.test(char) && !ORIGINAL_CHAR_REG.test(char)) {
      return true
    }
  }

  return false
}

/**
 * 判断字符中是否同时包含数字和字母.
 */
export const includesNumAndLetter = (value: string): boolean => {
  let char
  let hasNumber = false
  let hasLetter = false

  for (let i = 0; i < value.length; i++) {
    char = value[i]

    if (NUMBER_REG.test(char)) {
      hasNumber = true
    } else if (LETTER_REG.test(char)) {
      hasLetter = true
    }

    if (hasNumber && hasLetter) {
      return true
    }
  }

  return hasNumber && hasLetter
}

/**
 * 验证密码是否符合规则.
 *
 * 6 - 16 位至少包含数字和字母.
 *
 * @returns true / false.
 */
export const validatePassword = (value: string): boolean => {
  return value.length >= 6 && value.length <= 16 && includesNumAndLetter(value)
}

/**
 * 计算给定的时间距离现在是多久之前.
 * @param {string} time 相对现在的时间, 建议格式: YYYY-MM-DD HH:mm:ss.
 */
export const calcAgoTime = (time) => {
  const m1 = moment()
  const m2 = moment(time)
  const diff = m1.diff(m2)

  // 各时间毫秒数.
  const year = 365 * 24 * 60 * 60 * 1000
  const day = 24 * 60 * 60 * 1000
  const hour = 60 * 60 * 1000
  const minute = 60 * 1000

  const diffYears = Math.floor(diff / year)
  if (diffYears > 0) {
    return `${diffYears}年前`
  }

  const diffDays = Math.floor((diff % year) / day)
  if (diffDays > 0) {
    return `${diffDays}天前`
  }

  const diffHours = Math.floor((diff % day) / hour)
  if (diffHours > 0) {
    return `${diffHours}小时前`
  }

  const diffMinutes = Math.floor((diff % hour) / minute)
  if (diffMinutes > 5) {
    return `${diffMinutes}分钟前`
  }

  return '刚刚'
}

export const mergeIntervals = function (intervals: number[][]): number[][] {
  intervals.sort((a, b) => {
    return a[0] - b[0]
  })
  const r: number[][] = []
  let temp = intervals[0]
  for (let i = 1; i < intervals.length; i++) {
    const item = intervals[i]
    if (temp[1] >= item[0]) {
      temp[1] = Math.max(temp[1], item[1])
    } else {
      r.push(temp)
      temp = item
    }
  }
  r.push(temp)
  return r
}

/**
 * 区编码倒退省市区数据
 * @param areaCode 区编码
 */
export const formatAreaCode = (areaCode: number): number[] => {
  if (!areaCode) return []
  const areaCodeStr = areaCode.toString()
  const data = areaCodeStr.length > 6 ? areaCodeStr.slice(0, 6) : areaCodeStr
  const p = Number(data.substring(0, 2).padEnd(6, '0'))
  const c = Number(data.substring(0, 4).padEnd(6, '0'))
  const d = Number(data)
  return [p, c, d]
}

/**
 * 打开新页面
 * */
export const openNewTab = (url) => {
  if (!url) {
    return
  }
  if (process.env.NODE_ENV === 'development') {
    alert(`跳转地址为：${url}`)
  } else {
    window.open(url)
  }
}
